export default {
  "entityPicker_error": "An error occurred, while getting the entities.",
  "entityPicker_landmark": "Select Landmark",
  "entityPicker_equipments": "Select Equipment"
}